// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {
  FETCH_USERS,
} from '../actions/userManagement'

const initialState = {
  users: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS:
      return {...state, users: action.payload.users}
    default:
      return state
  }
}
